import { useContext } from 'react';
import StoresContext from "../contexts/StoresContext.js";

function useStores(nullable) {
  var stores = useContext(StoresContext);

  if (!stores && !nullable) {
    throw new Error('useStores must be used within StoresContext');
  }

  return stores;
}

export default useStores;